module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col title"
  }, [_vm._v("Submission of Files")]), _vm._v(" "), _c('div', {
    staticClass: "col-3 pl-1 hidden-md-up"
  }, [_c('for-authors-mobile-menu', {
    attrs: {
      "anchors-list": _vm.anchorsList
    }
  })], 1)]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n      Please carefully read the Instructions for Authors in the submission system.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      When submitting manuscripts, authors are strongly encouraged to upload original source files into the system.\n      Uploading original source files will greatly facilitate publication of an accepted manuscript. Submit all\n      files via submission system, no emails. The following are acceptable file formats:\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      Manuscript files: Word, WordPerfect (doc or docx). No other format.\n      Graphics files: TIFF (preferable), JPG, PPT or PPTX, EPS format.\n      Once you have successfully submitted your manuscript online, you will receive acknowledgment via email.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      In submission system, please provide names, Institutions, real emails of ALL co- authors.\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-97271c06"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/for-authors/for-authors-submission/ForAuthorsFileSubmissionContent.vue
// module id = 1464
// module chunks = 1